import styled from "styled-components";

const AdminSearchInput = styled.input.attrs(({ type }) => ({
  type: type || "search",
}))`
  min-width: min(100%, 260px);
  flex: 1 1 260px;
  min-height: 42px;
  padding: 0.7rem 0.85rem;

  border:
    1px solid
    rgba(255, 255, 255, 0.13);

  border-radius: 12px;

  background: #151d31;
  color: #f7f7f7;

  outline: none;

  &::placeholder {
    color: rgba(247, 247, 247, 0.48);
  }

  &:focus-visible {
    outline:
      3px solid
      rgba(137, 179, 255, 0.32);

    outline-offset: 1px;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

export default AdminSearchInput;
